<template>
    <modal dialog="modal-lg" class="dark-top" :header="true" :customClass="'heightAuto'" :footer="true">

        <div slot="title">
            <h2>Edit Scheduled Task</h2>
        </div>

        <div slot="body" class="p-4">
            <schedule-task-form :scheduleTask="getSelectedScheduledTask" :editMode="true" @validationChanged="validationChanged" />
        </div>

        <div slot="footer" class="d-flex w-100 justify-content-end align-items-center">
            <button type="button" class="btn cancel wider" @click="pressCancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressSave" :disabled="isFormInvalid">Save</button>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from './Modal'

import scheduleTaskForm from '@/components/scheduleTasks/components/scheduleTaskForm'

export default {
    created: function () {
        this.prepareScheduleTaskToEdit()
    },
    data: function() {
        return {
            isFormInvalid: false,
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedScheduledTask',
        ]),
    },
    methods: {
        ...mapActions([
            'editScheduleTask',
            'downloadScheduledTasks',
            'closeModal',
        ]),
        prepareScheduleTaskToEdit: function () {
            // parse jsonParameters only one time
            let jsonParameters = this.getSelectedScheduledTask.jsonParameters? JSON.parse(this.getSelectedScheduledTask.jsonParameters) : null

            // INVOICE
            if(this.getSelectedScheduledTask.taskType == 10000){
                this.$set(this.getSelectedScheduledTask, 'channelIdList', jsonParameters.channelIdList)
                this.$set(this.getSelectedScheduledTask, 'agentIdList', jsonParameters.agentIdList)
                this.$set(this.getSelectedScheduledTask, 'isToDeliverDocumentToEachEntity', jsonParameters.isToDeliverDocumentToEachEntity)
                this.$set(this.getSelectedScheduledTask, 'cron', jsonParameters.cron)
                this.$set(this.getSelectedScheduledTask, 'emailListToSendResume', jsonParameters.emailListToSendResume)
            }
        },
        validationChanged: function(isInvalid) {
            this.isFormInvalid = isInvalid
        },
        pressCancel: function() {
            this.closeModal();
        },
        pressSave: function() {
            this.editScheduleTask(this.getSelectedScheduledTask).then(response => {
                this.downloadScheduledTasks()
            })
            this.closeModal();
        },
    },
    components: {
        Modal,
        scheduleTaskForm
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ScheduleTaskEdit.vue?193d4c44